module.exports = __webpack_public_path__ + "media/images/emblems/Merenschwand-blason-7777c180ba1064b0b31dc8236f201133.png";